import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { useMediaTypeOptions, useSectorOptions } from "@shared/options";

export function BookCategoryForm() {
  const translate = useTranslate();

  const { getSectorOptions } = useSectorOptions();
  const { getMediaTypeOptions } = useMediaTypeOptions();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("book_category_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="type"
          label={translate("book_category_admin.fields.type")}
          options={getMediaTypeOptions()}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="sector"
          label={translate("book_category_admin.fields.sector")}
          options={getSectorOptions()}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.SinglePhotoPicker
          name="image"
          label={translate("book_category_admin.fields.image")}
        />
      </Grid>
    </Grid>
  )
}
